$(function(){
    function tabUpdate(dest){
		var target = $('#'+dest);
		if(target.length > -1){
			target.fadeIn().siblings('.view').hide();
		}
	}
	$('.view-button-container').each(function(){
		var tab = $(this).find('.view-button');
		tab.click(function(){
			$(this).addClass('active').siblings().removeClass('active');
			tabUpdate($(this).attr('data-target'))
		}).first().click();
	});
});